import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const uploadPaymentSheet = (formData, type, year, month) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        const uploadPath = useExpress ? `/producer-monthly-reports/upload/${type}/${year}/${month}` : `/upload-monthly-report/${type}/${year}/${month}`;
        axios
            .post(`${host}${uploadPath}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject(new Error('Unable to upload file. Please contact support.'));
            });
    });

export default uploadPaymentSheet;
